import { InternalAxiosRequestConfig, AxiosHeaders } from 'axios';

export const getAuthHeaders = (): { headers?: AxiosHeaders } => {
  // В продакшене не добавляем токен, так как запросы идут изнутри пода
  if (process.env.NODE_ENV === 'production') {
    return {};
  }

  // В development добавляем тестовый токен для локальной разработки
  const headers = new AxiosHeaders();
  headers.set('X-API-Token', process.env.VITE_API_TOKEN || 'test-token');
  
  return { headers };
};

export const addAuthHeaders = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  const authHeaders = getAuthHeaders();
  if (!authHeaders.headers) {
    return config;
  }

  const headers = new AxiosHeaders(config.headers);
  
  // Добавляем auth заголовки
  for (const [key, value] of Object.entries(authHeaders.headers)) {
    headers.set(key, value);
  }

  return {
    ...config,
    headers
  };
};